export default {
    1: {
        id: 1,
        text: 'normal',
        type: 'success'
    },
    2: {
        id: 2,
        text: 'Baja',
        type: 'danger'
    },
    3: {
        id: 3,
        text: 'Reimpresión',
        type: 'warning'
    },
    4: {
        id: 4,
        text: 'Denunciada',
        type: 'error'
    },
    5: {
        id: 5,
        text: 'Renovada',
        type: 'info'
    },
    6: {
        id: 6,
        text: 'Bloqueada',
        type: 'error'
    },
    7: {
        id: 7,
        text: 'Inhabilitada',
        type: 'error'
    },
    8: {
        id: 8,
        text: 'Denunciada IVR',
        type: 'error'
    },
    9: {
        id: 9,
        text: 'Bloqueada IVR',
        type: 'error'
    },
    10: {
        id: 10,
        text: 'Vencida',
        type: 'dark'
    }
};
